import React from 'react';
interface Props {
  message?: string;
  style?: React.CSSProperties;
}

export const LoadingScreen: React.FC<Props> = ({ message, style }) => {
  return (
    <div className="loader-wrap">
      <div className="loader" style={style}>
        <h2>{message ?? 'Loading...'}</h2>
      </div>
    </div>
  );
};
